import { connect } from 'react-redux'
import GeofenceMap from './GeofenceMap'
import * as actions from '../../redux/branches'

const mapStateToProps = (state) => ({
  branch: state.branches.selectedBranch
})

export default connect(mapStateToProps, actions)(GeofenceMap)